<template>
    <div>
        <el-dialog v-if="!showSuccess" :title="title" :visible="true" :modal="true" :show-close="false" class="dialog-box dialog-save-plan">
        <img src="../assets/images/tuoyuan.png" alt="背景图" class="dialog-img">
        <img src="../assets/images/close.png" alt="关闭" @click="cancelSavePlanHandler">
        <el-form :model="ruleForm" ref="ruleForm" :rules="rules" :label-width="formLabelWidth">
            <el-form-item label="志愿表标题：" prop="plan_title">
                <el-input v-model="ruleForm.plan_title" autocomplete="off" placeholder="请输入志愿表标题">
                </el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <div>
                <el-button @click="cancelSavePlanHandler" class="vip-btn1">取消</el-button>
                <el-button @click="savePlanHandler" class="vip-btn2">保存</el-button>
            </div>
            <!-- <p class="dialog-p">提示：</p>
            <p>保存后不可编辑，可在个人中心志愿列表查看。</p> -->
        </div>
        </el-dialog>
        <el-dialog v-if="showSuccess" :visible="true" :modal="true" :show-close="false" class="dialog-box dialog-save-plan dialog-save-plan-after">
            <img src="../assets/images/tuoyuan.png" alt="背景图" class="dialog-img">
            <img src="../assets/images/close.png" alt="关闭" @click="cancelSavePlanHandler">
            <img src="../assets/images/zhiyuan_success.png" class="dialog-img-success">
            <h3>志愿表保存成功</h3>
            <div slot="footer" class="dialog-footer">
                <div>
                    <el-button @click="cancelSavePlanHandler" class="vip-btn1">继续填报</el-button>
                    <el-button @click="gotoDetailHandler" class="vip-btn2">查看志愿表</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { planSubmit, editPlanSubmit } from '@/api/zhiyuan'
export default {
    name: "Vip",
    data() {
        const validateTitle = (rule, value, callback) => {
			if (value.length === 0) {
                callback(new Error("请输入志愿表标题"));
			} else {
                callback();
            }
		};
        return {
            ruleForm: {
                plan_title: ''
            },
            showSuccess: false,
            detail_id: '',
            rules: {
                plan_title: [
                    {trigger: 'blur', validator: validateTitle }
                ],
            },
            formLabelWidth:'110px',
            title: '保存志愿表'
        };
    },
    computed: {
        ...mapState({
            savePlanInfor: state => state.user.savePlanInfor,
        })
    },
    mounted() {
        if(this.savePlanInfor.flag == 'edit') {
            this.ruleForm.plan_title = this.savePlanInfor.plan_title
            this.title = '修改志愿表'
        } else if(this.savePlanInfor.flag == 'add') {
            this.ruleForm.plan_title = this.savePlanInfor.exam_name
            this.title = '保存志愿表'
        }
    },
    methods: {
        cancelSavePlanHandler() {
            this.$store.commit('user/SHOWSAVEPLAN', false);
        },
        savePlanHandler() {
            let _this = this;
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    const savePlanInfor = this.$store.state.user.savePlanInfor
                    savePlanInfor.plan_title = this.ruleForm.plan_title
                    if(savePlanInfor.plan_type == '2') {
                        savePlanInfor.plan_base_info.exam_name = this.ruleForm.plan_title
                    }
                    if(savePlanInfor.flag == 'edit') {
                        editPlanSubmit(savePlanInfor).then(res => {
                            if(res.data) {
                                this.showSuccess = true
                                this.detail_id = savePlanInfor.id
                                localStorage.removeItem('savePlanData');
                            } else {
                                this.$message({
                                    message: '修改志愿表失败',
                                    type: 'error'
                                });
                            }
                        })
                    } else {
                        planSubmit(savePlanInfor).then(res => {
                            if(res.data) {
                                this.showSuccess = true
                                this.detail_id = res.data.id
                                localStorage.removeItem('savePlanData');
                            } else {
                                this.$message({
                                    message: '添加志愿表失败',
                                    type: 'error'
                                });
                            }
                        })
                    }
                }
            })
        },
        closeHandler() {
            this.$store.commit('user/SHOWSAVEPLAN', false);
        },
        gotoDetailHandler() {
            this.$store.commit('user/SHOWSAVEPLAN', false);
            this.$router.push({
                path: '/detail',
                query: {
                    id: this.detail_id
                }
            })
        }
    }
}
</script>

<style lang='scss' scoped>
.dialog-box {
    img {
        width: 24px;
        height: 24px;
        position: absolute;
        right: 40px;
        top: 40px;
        z-index: 999;
    }
    p {
        margin: 40px 0;
        color: #5e6166;
        font-size: 16px;
        position: relative;
        z-index: 9999;
        text-align: left;
        margin: 0;
        line-height: 30px;
    }
    .dialog-footer {
        padding: 0;
        button {
            width: 240px;
            height: 52px;
            border-radius: 8px;
            font-size: 18px!important;
            border: none;
            margin-bottom: 30px;
        }
        .vip-btn1 {
            background: #e1e4eb!important;
            color: #5e6166!important;
            background: #e1e4eb!important;
            position: relative;
            left: -10px;
        }
        .vip-btn2 {
            background: linear-gradient(90deg,#ffa94a, #ff913c)!important;
            color: #ffffff!important;
            position: relative;
            right: -10px;
        }
        .dialog-p {
            font-weight: 600;
        }
    }
}
.dialog-save-plan-after {
    .dialog-img-success {
        width: 104px;
        height: 111px;
        position: relative;
        top: auto;
        right: auto;
        left: 50%;
        top: -20px;
        transform: translateX(-50%);
    }
    h3 {
        font-size: 22px;
        font-weight: 400;
        text-align: center;
        margin: 0; 
        color: #2c2e33;
        line-height: 30px;
        margin-bottom: 36px;
    }
}
</style>